import SliderManager from "./SliderManager.js";

const BREAKPOINT = 768;

const advantagesSlider = new SliderManager({
  selector: ".advantages__list",
  splideOptions: {
    label: "Преимущества",
    type: "loop",
    perPage: 1,
    perMove: 1,
    pagination: false,
    arrows: false,
    padding: { right: "13.3%" },
    focus: "center",
    trimSpace: false,
    updateOnMove: true,
    waitForTransition: true,
    gap: "24px",
  },
  globalVarName: "advantagesSlider",
  resizeDelay: 250,
  condition: () => window.innerWidth < BREAKPOINT,
  dynamicWrapper: {
    trackClass: "advantages__slider-track",
    itemClass: "advantages__item",
  },
});

advantagesSlider.init();
